import { render, staticRenderFns } from "./copyOrder.vue?vue&type=template&id=8bc93fa8&scoped=true&"
import script from "./copyOrder.vue?vue&type=script&lang=js&"
export * from "./copyOrder.vue?vue&type=script&lang=js&"
import style0 from "./copyOrder.vue?vue&type=style&index=0&id=8bc93fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc93fa8",
  null
  
)

export default component.exports